import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import {
  DEFAULT_PAGE_BANNER,
  pageBannerImage,
  pageBannerUrl,
  usePageBanner,
} from "./usePageBanner";
import PageBannerImage from "./PageBannerImage";

interface Props {
  banner: string;
  current: string;
  link: string;
  showMenu?: boolean;
  type?: string;
  children?: React.ReactNode;
  /** Brand (plum) tint over banner + white headline — matches site charte */
  tone?: "default" | "brand";
}
const PageHeaderAllPage = ({
  banner,
  current,
  link,
  showMenu,
  children,
  type,
  tone = "default",
}: Props) => {
  const { t, i18n } = useTranslation();
  const { banner: apiBanner, loading } = usePageBanner();
  const fallbackImage = banner?.trim() || DEFAULT_PAGE_BANNER;
  const image = loading ? null : pageBannerImage(apiBanner?.image_1920) || fallbackImage;
  const heading = apiBanner?.first_title || "";
  const subtitle = apiBanner?.second_title || "";
  const target = pageBannerUrl(apiBanner?.url);

  const isProfile = type === "profil";

  const textBlock =
    (heading || subtitle) && (
      <div className="ac-page-header__content">
        {heading ? <h1 className="ac-page-header__title">{heading}</h1> : null}
        {subtitle ? (
          <p className="ac-page-header__lead">{subtitle}</p>
        ) : null}
      </div>
    );

  const heroStageClass = isProfile
    ? "container position-absolute text-center ac-page-header__hero-stage ac-page-header__hero-stage--profile z-3"
    : `container position-absolute top-50 start-50 translate-middle text-center${
        tone === "brand"
          ? " ac-page-header__hero-stage z-3"
          : " z-1"
      }`;

  return (
    <div
      className={`page-header background-body ac-page-header${
        tone === "brand" ? " ac-page-header--brand" : ""
      }${isProfile ? " ac-page-header--profile" : ""}`}
    >
      <div
        className={`custom-container position-relative mx-auto${
          tone === "brand" ? " ac-page-header__shell" : ""
        }`}
        style={{ maxWidth: "100%" }}
      >
        {tone === "brand" ? (
          <div className="ac-page-header__hero">
            <PageBannerImage
              key={image ?? "loading"}
              className="ac-page-header__hero-img"
              src={image}
              decoding="async"
              fallback={fallbackImage}
            />
            {target && <a href={target} className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 2 }} aria-label={heading || current} />}
          </div>
        ) : (
          <div className="bg-overlay overflow-hidden position-relative">
            <PageBannerImage
              key={image ?? "loading"}
              className="w-100 h-100 img-banner"
              src={image}
              fallback={fallbackImage}
            />
            {target && <a href={target} className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 2 }} aria-label={heading || current} />}
          </div>
        )}
        {(heading || subtitle || isProfile) && (
          <div className={heroStageClass}>
            {textBlock}
            {isProfile && (
              <div className="profile-content ac-profile-header-wallet">
                {children}
              </div>
            )}
          </div>
        )}
        {showMenu && (
          <div
            className={`ac--breadcrumbs position-absolute start-50 translate-middle px-3 py-2 rounded-12 border d-flex gap-3 ac ${
              tone === "brand"
                ? "ac-page-header__crumbs ac-page-header__crumbs--on-hero"
                : "background-body z-1 top-100"
            }`}
          >
            <Breadcrumb
              separator={
                i18n.language === "ar" ? (
                  <IoIosArrowBack />
                ) : (
                  <IoIosArrowForward />
                )
              }
              items={[
                {
                  title: (
                    <span className="ac--color-extra-light-gray text-md-medium">
                      {t("menu.home")}
                    </span>
                  ),
                  href: "/",
                },
                {
                  title: (
                    <span className="ac--color-primary text-md-bold">
                      {current}
                    </span>
                  ),
                },
              ]}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default PageHeaderAllPage;
